// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3418N","question":"styles_question__2usaU","description":"styles_description__UXKkj"};